import { useApi, createApiHook } from "../utils/apiUtils";

const useAssociateInstrumentQuestionnaire = () => {
  const { apiPost } = useApi();
  const useApiState = createApiHook(null);
  const { data, error, loading, startLoading, setResponse } = useApiState();

  const associateInstrument = async (instrumentId, payload) => {
    startLoading();
    const response = await apiPost(`/instruments/${instrumentId}/associate_questionnaire`, "Error al asociar el cuestionario", payload);
    setResponse(response);
    return !response?.error;
  };

  return { associateInstrument, data, error, loading };
};

export default useAssociateInstrumentQuestionnaire;
